export default function () {
  this.loadAccesses()
  this.loadTotals('teacher')
  this.loadTotals('student')
}
